<app-navbar></app-navbar>
<div class="relative">
    <router-outlet class="relative"></router-outlet>
    <app-container-toast></app-container-toast>
</div>
<app-footer></app-footer>